import React, {Component} from 'react'
import {Popup, Button, Modal, Form, Icon} from 'semantic-ui-react'
import Utils from '../../modules/utils'
import {colorOptionsCads2, brandOptions, brandOptions_org7, divisionOptions, divisionOptions_org7, categoryOptionsCads2, categoryOptionsCads2_org7, subcategoryOptionsCads2, packsOptionsCads2, missingBrandOptions} from '../generate-style-number/options'
import {seasonOptions} from './options'
import { createPortal } from 'react-dom'

const clearInputsState = {
  open: true,
  description: '',
  brand: null,
  division: null,
  category: null,
  subcategory: null,
  color: [],
  packs: null,
  fabrication: null,
  sizes: null,
  season: null,
  groupId: null,
  message: null
}

const SuccessToast = (message, hideMessage) => {
  return createPortal(
    <div style={{position: 'fixed', left: 0, padding: '10px', border: '1px solid rgb(230,230,230)', borderRadius: '2px', background: 'white', top: '75px', zIndex: 9, width: '100%', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05)', background: 'lightgreen'}}>
      {message}
      <Popup content='Close' position='right center'
        trigger={
          <Icon name='close' style={{color: 'rgb(228,203,131)', cursor: 'pointer', float: 'right'}}
            onClick={hideMessage}
          />
        }
      />
    </div>,
    document.getElementById('toast-portal')
  )
}

class BulkEditCad extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      description: '',
      brand: null,
      division: null,
      category: null,
      subcategory: null,
      color: [],
      packs: null,
      fabrication: null,
      sizes: null,
      season: null,
      groupId: null,
      message: null
    }
  }

  clickButton = () => {
    let {cadIds} = this.props
    let ids = Object.keys(cadIds)
    if (ids.length == 0) {
      alert('Please select at least one cad!')
    } else {
      this.setState(clearInputsState)
    }
  }

  onClose = () => {
    this.setState({open: false})
  }

  descriptionOnChange = (event, {value}) => {
    this.setState({description: value})
  }

  saveChanges = () => {
    let {cadIds} = this.props
    let {
      description, brand, division, category, subcategory,
      color, packs, fabrication, sizes, season, groupId
    } = this.state
    let ids = Object.keys(cadIds)
    const data = {
      cad_ids: ids, description, brand, division, category, subcategory,
      color, packs, fabrication, sizes, season, groupId
    }
    Utils.post('bulk_edit', data, (err, res) =>
    {
      if (err) {
        alert('There was an error when trying to bulk edit.')
      } else {
        let {message} = res.data
        this.setState({message})
        this.onClose()
        // console.log(JSON.parse(res.data.updated))
      }
    })
  }

  fieldOnChange = (event, {value, name}) => {
    let newState = {}
    newState[name] = value
    this.setState(newState)
  }

  hideMessage = () => {
    this.setState({message: null})
  }

  render() {
    let {orgId} = this.props
    let {
      open, description, brand, division, category, subcategory,
      color, packs, season, groupId, message
    } = this.state

    let _brands = [], _divisions = [], _categories = []
    if ([1,2,5].includes(orgId)) {
      _brands = brandOptions.concat(missingBrandOptions)
      _divisions = divisionOptions
      _categories = categoryOptionsCads2
    } else if (orgId == 7) {
      _brands = brandOptions_org7
      _divisions = divisionOptions_org7
      _categories = categoryOptionsCads2_org7
    }

    return (
      <React.Fragment>
        {
          message != null
          ?
          SuccessToast(message, this.hideMessage)
          :
          null
        }
        <Popup content='Edit' position='right center'
          trigger={
            <Button onClick={this.clickButton} basic circular icon='pencil' style={{marginTop: '2px'}}/>
          }
        />
        <Modal size='large' open={open} onClose={this.onClose} closeIcon>
          <Modal.Header>Bulk edit cads</Modal.Header>
          <Modal.Content>
            <Form id="my-bulk-form" onSubmit={this.saveChanges}>
              <Form.Group widths='equal'>
                <Form.Input fluid label='Description' type='text' onChange={this.descriptionOnChange} placeholder='Description' value={description} />
                <Form.Input fluid label='Group ID' type='number' min='0' max='9999999' step='1' onChange={this.fieldOnChange} name='groupId' placeholder='Group ID' value={groupId} />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Select fluid search label='Brand' onChange={this.fieldOnChange} name='brand' options={_brands} placeholder='Brand' value={brand} />
                <Form.Select fluid search label='Division' onChange={this.fieldOnChange} name='division' options={_divisions} placeholder='Division' value={division} />
                <Form.Select fluid search label='Category' onChange={this.fieldOnChange} name='category' options={_categories} placeholder='Category' value={category} />
                <Form.Select fluid search label='Sub-category' onChange={this.fieldOnChange} name='subcategory' options={subcategoryOptionsCads2} placeholder='Sub-category' value={subcategory} />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Select fluid multiple search label='Color' onChange={this.fieldOnChange} name='color' options={colorOptionsCads2} placeholder='Color' value={color} />
                <Form.Select fluid search label='Packs' onChange={this.fieldOnChange} name='packs' options={packsOptionsCads2} placeholder='Packs' value={packs} />
                <Form.Select fluid search label='Season' onChange={this.fieldOnChange} name='season' options={seasonOptions} placeholder='Season' value={season} />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button type="submit" form="my-bulk-form" primary>
              Save
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }
}

export default BulkEditCad
